import { CartApprovalStatus, CartGetData } from './cart';

export enum MembershipRoleEnum {
  admin = 'admin',
  approver = 'approver',
  member = 'member',
}

/**
 * active: user is active in the organization
 * pending: user is pending approval
 * removed: user is removed from the organization
 */
export enum MembershipStatusEnum {
  active = 'active',
  pending = 'pending',
  removed = 'removed',
}

export enum OrgSortByEnum {
  role = 'role',
  name = 'name',
  status = 'status',
  email = 'email',
}

export enum OrgFilterByEnum {
  all = 'all',
  active = 'active',
  pending = 'pending',
}

export type MembershipRole = keyof typeof MembershipRoleEnum;
export type MembershipStatus = keyof typeof MembershipStatusEnum;
export type OrgSortBy = keyof typeof OrgSortByEnum;
export type OrgFilterBy = keyof typeof OrgFilterByEnum;

export interface Org {
  id: string;
  users: OrgMember[]; // string of user ids
  approvedVendors: string[]; // string of vendor ids
}

export interface OrgMembership {
  organizationId: string;
  role: MembershipRole;
  joinedTimestamp: number;
  status: MembershipStatus; // pending, active, suspended
}

// Same as OrgMemberProfile on the server
export interface OrgMember {
  id: string;
  name: string;
  email: string;
  role: MembershipRole;
  status: MembershipStatus;
  photo?: string;
}

export interface OrgQueriesData {
  users: OrgMember[];
  totalUsers: number;
  pageParam: number;
}

// Organization Settings Tabs
export enum OrgTabOptionsValueEnum {
  users = 'users',
  vendors = 'vendors',
  settings = 'settings',
  analytics = 'analytics',
}
export type OrgTabOptionsValue = keyof typeof OrgTabOptionsValueEnum;

export type OrgAnalytics = {
  cartApproved: string;
  formattedCartPrice: string;
  formattedDate: string;
  linkToCart: string;
  cart: CartGetData;
  requestedBy: {
    email: string;
    name: null | string;
  };
  requestedAt: number;
  status: CartApprovalStatus;
};

export type OrgActiveAndOrRemovedUsers = {
  id: string;
  role: MembershipRole;
  status: MembershipStatus;
  email: string;
  name?: string;
  photo?: string;
};

export type OrgAnalyticsExcelData = {
  analytics: {
    cartApproved: string;
    formattedCartPrice: string;
    formattedDate: string;
    linkToCart: string;
    cart: CartGetData;
    requestedBy: {
      email: string;
      name: null | string;
    };
    requestedAt: number;
    status: CartApprovalStatus;
  }[];
  totalCarts: number;
  totalItems: number;
  totalPrice: string;
};

export type OrganizationSettings = {
  namedApprovers: boolean;
  multiLayerApproval: boolean;
};
